module.exports = __webpack_public_path__ + "img/4C342A_7B584B_271912_6B4C44-256px.e9b0ad76.png";